import React from 'react';


export const useTimeoutEffect = (callback, dependencies, millis) => useTimerFunc(callback, React.useEffect, setTimeout, clearTimeout, dependencies, millis);

export const useIntervalEffect = (callback, dependencies, millis) => useTimerFunc(callback, React.useEffect, setInterval, clearInterval, dependencies, millis);


const useTimerFunc = (callback, useFunc, setTimer, clearTimer, dependencies, millis) => {
  const count = React.useRef(0);
  
  return useFunc(() => {
    let timer = setTimer(() => {
      timer = null;
      
      callback(count.current++);
    }, millis);
    
    return () => timer && clearTimer(timer);
  }, dependencies);
};
